/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import '../vendors/nextparticle.min';
import ScrollTrigger from '../vendors/ScrollTrigger.min';
import Draggable from '../vendors/Draggable.min';
import './ajax-team.js';
import './ajax-search.js';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
		if ( jQuery( 'body' ).hasClass( 'single single-post dark-mode' ) ) {
			jQuery( 'header' ).removeClass( 'white-header' );
		} else if ( jQuery( 'body' ).hasClass( 'single single-post ' ) ) {
			jQuery( 'header' ).addClass( 'white-header' );
		}
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
		if ( jQuery( 'body' ).hasClass( 'single single-post  dark-mode' ) ) {
			jQuery( 'header' ).removeClass( 'white-header' );
		}
	}

	if ( jQuery( '.hero-bg-image' ).length > 0 && window.scrollY > 0 ) {
		jQuery( '.header-section' ).addClass( 'transparent-header' );
	} else {
		jQuery( '.header-section' ).removeClass( 'transparent-header' );
	}
} );

jQuery( function() {
	setTimeout( () => {
		if ( jQuery( '.home-with-animation' ).length > 0 ) {
			if ( jQuery( '#brain-particle' ).length > 0 ) {
				const logoBrain = document.getElementById( 'brain-particle' );
				const nextParticleBrain = new NextParticle( {
					image: logoBrain,
					particleGap: 2,
					particleSize: 0.8,
					initPosition: 'none',
					initDirection: 'none',
					mouseForce: 20,
					noise: 10,
					width: logoBrain.offsetWidth,
					height: logoBrain.offsetHeight + 80,
				} );
			}

			if ( jQuery( '#logo-particle' ).length > 0 ) {
				const logo = document.getElementById( 'logo-particle' );
				const nextParticleBody = new NextParticle( {
					image: logo,
					initPosition: 'none',
					initDirection: 'none',
					mouseForce: 15,
					width: logo.offsetWidth,
					height: logo.offsetHeight + 80,
				} );
			}
		}
	}, 100 );

	jQuery( "section.cta-section[data-wpr-lazyrender='1']" ).removeAttr( 'data-wpr-lazyrender' );

	if ( jQuery( window ).width() > 1003 ) {
		let lastScrollTop = 0,
			delta = 15;
		let adjustmentHeader = 0;

		if ( jQuery( 'body' ).hasClass( 'logged-in admin-bar' ) ) {
			adjustmentHeader = 32;

			if ( window.innerWidth < 783 ) {
				adjustmentHeader = 46;
			}
		}
		const totalHeaderHeight = jQuery( '.header-section' ).outerHeight() + jQuery( '.top-bar' ).outerHeight() + adjustmentHeader;

		jQuery( window ).scroll( function( event ) {
			const st = jQuery( this ).scrollTop();

			if ( Math.abs( lastScrollTop - st ) <= delta ) {
				return;
			}
			if ( st > lastScrollTop && lastScrollTop > 0 ) {
				jQuery( '.header-section' ).css( 'top', '-' + totalHeaderHeight + 'px' );
				jQuery( 'body' ).addClass( 'nav-up' );
				jQuery( 'body' ).removeClass( 'nav-down' );
			} else {
				jQuery( '.header-section' ).css( 'top', adjustmentHeader + 'px' );
				jQuery( 'body' ).removeClass( 'nav-up' );
				jQuery( 'body' ).addClass( 'nav-down' );
			}
			lastScrollTop = st;
		} );
	}
	function toggleHeaderClass() {
		if ( jQuery( '.hero-bg-image' ).length > 0 ) {
			if ( jQuery( window ).scrollTop() === 0 ) {
				jQuery( '.header-section' ).addClass( 'transparent-header' );
			} else {
				jQuery( '.header-section' ).removeClass( 'transparent-header' );
			}
		}
	}

	// Run on page load
	toggleHeaderClass();

	// Run on scroll
	jQuery( window ).on( 'scroll', toggleHeaderClass );

	/**
	 *
	 * 	* Footer stats
	 *
	 */

	if ( jQuery( '.footer-stats-ctn' ).length > 0 ) {
		jQuery( '.footer-stat' ).on( 'mouseenter', function() {
			jQuery( '.footer-stat' ).not( this ).css( 'opacity', '0.4' );
			jQuery( this ).css( 'opacity', '1' );
		} );

		jQuery( '.footer-stat' ).on( 'mouseleave', function() {
			jQuery( '.footer-stat' ).css( 'opacity', '1' );
		} );

		jQuery.noConflict();
	}

	if ( jQuery( '.winner-section' ).length > 0 ) {
		function handleFiltering( selectedYear, selectedArea ) {
			jQuery( '.winner-row-item' ).hide();
			jQuery( '.section-head-repeater .section-head' ).hide();
			jQuery( '.region-item' ).show();

			const filteredItems = jQuery( '.winner-row-item[data-year="' + selectedYear + '"][data-origin="' + selectedArea + '"]' );
			const filteresectionHead = jQuery( '.section-head[data-year="' + selectedYear + '"]' );

			if ( filteredItems.length > 0 ) {
				filteredItems.show();
			} else {
				jQuery( '.region-item' ).hide();
			}

			if ( filteresectionHead.length > 0 ) {
				filteresectionHead.show();
			}

			function hideEmptyRegionItems() {
				jQuery( '.region-item' ).each( function() {
					const allHidden = jQuery( this ).find( '.winner-row-item' ).toArray().every( ( item ) => jQuery( item ).css( 'display' ) === 'none' );
					if ( allHidden ) {
						jQuery( this ).hide();
					} else {
						jQuery( this ).show();
					}
				} );
			}

			hideEmptyRegionItems();
		}

		function getSelectedValues() {
			const selectedYear = jQuery( '.year-dropdown .select-dropdown__button' ).text().trim();
			const selectedArea = jQuery( '.area-dropdown .select-dropdown__button' ).text().trim();
			return { selectedYear, selectedArea };
		}

		// Window Load
		const { selectedYear, selectedArea } = getSelectedValues();
		handleFiltering( selectedYear, selectedArea );

		// Event Listener for button click
		jQuery( '.button-area a.button' ).on( 'click', function( e ) {
			e.preventDefault();
			const { selectedYear, selectedArea } = getSelectedValues();
			handleFiltering( selectedYear, selectedArea );
			jQuery( 'html, body' ).animate( {
				scrollTop: jQuery( '#winner-section-start' ).offset().top - 200,
			}, 800 );
		} );
	}

	if ( jQuery( '.awwards-hero' ).length > 0 ) {
		const loops = gsap.utils.toArray( '.awwards-hero' ).map( ( line, i ) => {
			line.querySelectorAll( '.awwards-hero-image' ).forEach( ( item ) => {
				const clone = item.cloneNode( ! 0 );
				line.appendChild( clone );
			} );
			const links = line.querySelectorAll( '.awwards-hero-image' ),
				tl = horizontalLoop( links, {
					repeat: -1,
					speed: 0.5 + i * 1,
					draggable: false,
					reversed: false,
					paddingRight: parseFloat( gsap.getProperty( links[ 0 ], 'marginRight', 'px' ) ),
				} );
			links.forEach( ( link ) => {
				link.addEventListener( 'mouseenter', () => gsap.to( tl, {
					timeScale: 0,
					overwrite: true,
				} ) );
				link.addEventListener( 'mouseleave', () => gsap.to( tl, {
					timeScale: i ? -1 : 1,
					overwrite: true,
				} ) );
			} );
		} );
		if ( jQuery( window ).width() < 1003 ) {
			const loops = gsap.utils.toArray( '.awwards-hero' ).map( ( line, i ) => {
				line.querySelectorAll( '.awwards-hero-image' ).forEach( ( item ) => {
					const clone = item.cloneNode( ! 0 );
					line.appendChild( clone );
				} );
				const links = line.querySelectorAll( '.awwards-hero-image' ),
					tl = horizontalLoop( links, {
						repeat: -1,
						speed: 0.5 + i * 0.5,
						draggable: false,
						reversed: false,
						paddingRight: parseFloat( gsap.getProperty( links[ 0 ], 'marginRight', 'px' ) ),
					} );
				links.forEach( ( link ) => {
					link.addEventListener( 'mouseenter', () => gsap.to( tl, {
						timeScale: 0,
						overwrite: true,
					} ) );
					link.addEventListener( 'mouseleave', () => gsap.to( tl, {
						timeScale: i ? -1 : 1,
						overwrite: true,
					} ) );
				} );
			} );
		}
		let currentScroll = 0;
		let scrollDirection = 1;
		window.addEventListener( 'scroll', () => {
			const direction = window.pageYOffset > currentScroll ? 1 : -1;
			if ( direction !== scrollDirection ) {
				loops.forEach( ( tl ) => gsap.to( tl, {
					timeScale: direction,
					overwrite: true,
				} ) );
				scrollDirection = direction;
			}
			currentScroll = window.pageYOffset;
		} );
		function horizontalLoop( items, config ) {
			items = gsap.utils.toArray( items );
			config = config || {};
			let tl = gsap.timeline( {
					repeat: config.repeat,
					paused: config.paused,
					defaults: {
						ease: 'none',
					},
					onReverseComplete: () => tl.totalTime( tl.rawTime() + tl.duration() * 100 ),
				} ),
				length = items.length,
				startX = items[ 0 ].offsetLeft,
				times = [],
				widths = [],
				xPercents = [],
				curIndex = 0,
				pixelsPerSecond = ( config.speed || 1 ) * 100,
				snap = config.snap === false ? ( v ) => v : gsap.utils.snap( config.snap || 1 ),
				populateWidths = () => items.forEach( ( el, i ) => {
					widths[ i ] = parseFloat( gsap.getProperty( el, 'width', 'px' ) );
					xPercents[ i ] = snap( parseFloat( gsap.getProperty( el, 'x', 'px' ) ) / widths[ i ] * 100 + gsap.getProperty( el, 'xPercent' ) );
				} ),
				getTotalWidth = () => items[ length - 1 ].offsetLeft + xPercents[ length - 1 ] / 100 * widths[ length - 1 ] - startX + items[ length - 1 ].offsetWidth * gsap.getProperty( items[ length - 1 ], 'scaleX' ) + ( parseFloat( config.paddingRight ) || 0 ),
				totalWidth,
				curX,
				distanceToStart,
				distanceToLoop,
				item,
				i;
			populateWidths();
			gsap.set( items, {
				xPercent: ( i ) => xPercents[ i ],
			} );
			gsap.set( items, {
				x: 0,
			} );
			totalWidth = getTotalWidth();
			for ( i = 0; i < length; i++ ) {
				item = items[ i ];
				curX = xPercents[ i ] / 100 * widths[ i ];
				distanceToStart = item.offsetLeft + curX - startX;
				distanceToLoop = distanceToStart + widths[ i ] * gsap.getProperty( item, 'scaleX' );
				tl.to( item, {
					xPercent: snap( ( curX - distanceToLoop ) / widths[ i ] * 100 ),
					duration: distanceToLoop / pixelsPerSecond,
				}, 0 ).fromTo( item, {
					xPercent: snap( ( curX - distanceToLoop + totalWidth ) / widths[ i ] * 100 ),
				}, {
					xPercent: xPercents[ i ],
					duration: ( curX - distanceToLoop + totalWidth - curX ) / pixelsPerSecond,
					immediateRender: false,
				}, distanceToLoop / pixelsPerSecond ).add( 'label' + i, distanceToStart / pixelsPerSecond );
				times[ i ] = distanceToStart / pixelsPerSecond;
			}
			function toIndex( index, vars ) {
				vars = vars || {};
				Math.abs( index - curIndex ) > length / 2 && ( index += index > curIndex ? -length : length ); // always go in the shortest direction
				let newIndex = gsap.utils.wrap( 0, length, index ),
					time = times[ newIndex ];
				if ( time > tl.time() !== index > curIndex ) {
					// if we're wrapping the timeline's playhead, make the proper adjustments
					vars.modifiers = {
						time: gsap.utils.wrap( 0, tl.duration() ),
					};
					time += tl.duration() * ( index > curIndex ? 1 : -1 );
				}
				curIndex = newIndex;
				vars.overwrite = true;
				return tl.tweenTo( time, vars );
			}
			tl.next = ( vars ) => toIndex( curIndex + 1, vars );
			tl.previous = ( vars ) => toIndex( curIndex - 1, vars );
			tl.current = () => curIndex;
			tl.toIndex = ( index, vars ) => toIndex( index, vars );
			tl.updateIndex = () => curIndex = Math.round( tl.progress() * ( items.length - 1 ) );
			tl.times = times;
			tl.progress( 1, true ).progress( 0, true ); // pre-render for performance
			if ( config.reversed ) {
				tl.vars.onReverseComplete();
				tl.reverse();
			}
			if ( config.draggable && typeof ( _vendors_Draggable_min__WEBPACK_IMPORTED_MODULE_6___default() ) === 'function' ) {
				let proxy = document.createElement( 'div' ),
					wrap = gsap.utils.wrap( 0, 1 ),
					ratio,
					startProgress,
					draggable,
					dragSnap,
					roundFactor,
					align = () => tl.progress( wrap( startProgress + ( draggable.startX - draggable.x ) * ratio ) ),
					syncIndex = () => tl.updateIndex();
				typeof InertiaPlugin === 'undefined' && console.warn( 'InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club' );
				draggable = _vendors_Draggable_min__WEBPACK_IMPORTED_MODULE_6___default().create( proxy, {
					trigger: items[ 0 ].parentNode,
					type: 'x',
					onPress() {
						startProgress = tl.progress();
						tl.progress( 0 );
						populateWidths();
						totalWidth = getTotalWidth();
						ratio = 1 / totalWidth;
						dragSnap = totalWidth / items.length;
						roundFactor = Math.pow( 10, ( ( dragSnap + '' ).split( '.' )[ 1 ] || '' ).length );
						tl.progress( startProgress );
					},
					onDrag: align,
					onThrowUpdate: align,
					inertia: true,
					snap: ( value ) => {
						const n = Math.round( parseFloat( value ) / dragSnap ) * dragSnap * roundFactor;
						return ( n - n % 1 ) / roundFactor;
					},
					onRelease: syncIndex,
					onThrowComplete: () => gsap.set( proxy, {
						x: 0,
					} ) && syncIndex(),
				} )[ 0 ];
			}
			return tl;
		}
	}

	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.image-collage-row' ).length > 0 ) {
			const loops = gsap.utils.toArray( '.image-collage-row' ).map( ( line, i ) => {
				line.querySelectorAll( '.image-collage' ).forEach( ( item ) => {
					const clone = item.cloneNode( ! 0 );
					line.appendChild( clone );
				} );
				const links = line.querySelectorAll( '.image-collage' ),
					tl = horizontalLoop( links, {
						repeat: -1,
						speed: 0.5 + i * 1,
						draggable: false,
						reversed: false,
						paddingRight: parseFloat( gsap.getProperty( links[ 0 ], 'marginRight', 'px' ) ),
					} );
				links.forEach( ( link ) => {
					link.addEventListener( 'mouseenter', () => gsap.to( tl, {
						timeScale: 0,
						overwrite: true,
					} ) );
					link.addEventListener( 'mouseleave', () => gsap.to( tl, {
						timeScale: i ? -1 : 1,
						overwrite: true,
					} ) );
				} );
			} );
			if ( jQuery( window ).width() < 1003 ) {
				const loops = gsap.utils.toArray( '.image-collage-row' ).map( ( line, i ) => {
					line.querySelectorAll( '.image-collage' ).forEach( ( item ) => {
						const clone = item.cloneNode( ! 0 );
						line.appendChild( clone );
					} );
					const links = line.querySelectorAll( '.image-collage' ),
						tl = horizontalLoop( links, {
							repeat: -1,
							speed: 0.5 + i * 0.5,
							draggable: false,
							reversed: false,
							paddingRight: parseFloat( gsap.getProperty( links[ 0 ], 'marginRight', 'px' ) ),
						} );
					links.forEach( ( link ) => {
						link.addEventListener( 'mouseenter', () => gsap.to( tl, {
							timeScale: 0,
							overwrite: true,
						} ) );
						link.addEventListener( 'mouseleave', () => gsap.to( tl, {
							timeScale: i ? -1 : 1,
							overwrite: true,
						} ) );
					} );
				} );
			}
			let currentScroll = 0;
			let scrollDirection = 1;
			window.addEventListener( 'scroll', () => {
				const direction = window.pageYOffset > currentScroll ? 1 : -1;
				if ( direction !== scrollDirection ) {
					loops.forEach( ( tl ) => gsap.to( tl, {
						timeScale: direction,
						overwrite: true,
					} ) );
					scrollDirection = direction;
				}
				currentScroll = window.pageYOffset;
			} );
			function horizontalLoop( items, config ) {
				items = gsap.utils.toArray( items );
				config = config || {};
				let tl = gsap.timeline( {
						repeat: config.repeat,
						paused: config.paused,
						defaults: {
							ease: 'none',
						},
						onReverseComplete: () => tl.totalTime( tl.rawTime() + tl.duration() * 100 ),
					} ),
					length = items.length,
					startX = items[ 0 ].offsetLeft,
					times = [],
					widths = [],
					xPercents = [],
					curIndex = 0,
					pixelsPerSecond = ( config.speed || 1 ) * 100,
					snap = config.snap === false ? ( v ) => v : gsap.utils.snap( config.snap || 1 ),
					populateWidths = () => items.forEach( ( el, i ) => {
						widths[ i ] = parseFloat( gsap.getProperty( el, 'width', 'px' ) );
						xPercents[ i ] = snap( parseFloat( gsap.getProperty( el, 'x', 'px' ) ) / widths[ i ] * 100 + gsap.getProperty( el, 'xPercent' ) );
					} ),
					getTotalWidth = () => items[ length - 1 ].offsetLeft + xPercents[ length - 1 ] / 100 * widths[ length - 1 ] - startX + items[ length - 1 ].offsetWidth * gsap.getProperty( items[ length - 1 ], 'scaleX' ) + ( parseFloat( config.paddingRight ) || 0 ),
					totalWidth,
					curX,
					distanceToStart,
					distanceToLoop,
					item,
					i;
				populateWidths();
				gsap.set( items, {
					xPercent: ( i ) => xPercents[ i ],
				} );
				gsap.set( items, {
					x: 0,
				} );
				totalWidth = getTotalWidth();
				for ( i = 0; i < length; i++ ) {
					item = items[ i ];
					curX = xPercents[ i ] / 100 * widths[ i ];
					distanceToStart = item.offsetLeft + curX - startX;
					distanceToLoop = distanceToStart + widths[ i ] * gsap.getProperty( item, 'scaleX' );
					tl.to( item, {
						xPercent: snap( ( curX - distanceToLoop ) / widths[ i ] * 100 ),
						duration: distanceToLoop / pixelsPerSecond,
					}, 0 ).fromTo( item, {
						xPercent: snap( ( curX - distanceToLoop + totalWidth ) / widths[ i ] * 100 ),
					}, {
						xPercent: xPercents[ i ],
						duration: ( curX - distanceToLoop + totalWidth - curX ) / pixelsPerSecond,
						immediateRender: false,
					}, distanceToLoop / pixelsPerSecond ).add( 'label' + i, distanceToStart / pixelsPerSecond );
					times[ i ] = distanceToStart / pixelsPerSecond;
				}
				function toIndex( index, vars ) {
					vars = vars || {};
					Math.abs( index - curIndex ) > length / 2 && ( index += index > curIndex ? -length : length ); // always go in the shortest direction
					let newIndex = gsap.utils.wrap( 0, length, index ),
						time = times[ newIndex ];
					if ( time > tl.time() !== index > curIndex ) {
					// if we're wrapping the timeline's playhead, make the proper adjustments
						vars.modifiers = {
							time: gsap.utils.wrap( 0, tl.duration() ),
						};
						time += tl.duration() * ( index > curIndex ? 1 : -1 );
					}
					curIndex = newIndex;
					vars.overwrite = true;
					return tl.tweenTo( time, vars );
				}
				tl.next = ( vars ) => toIndex( curIndex + 1, vars );
				tl.previous = ( vars ) => toIndex( curIndex - 1, vars );
				tl.current = () => curIndex;
				tl.toIndex = ( index, vars ) => toIndex( index, vars );
				tl.updateIndex = () => curIndex = Math.round( tl.progress() * ( items.length - 1 ) );
				tl.times = times;
				tl.progress( 1, true ).progress( 0, true ); // pre-render for performance
				if ( config.reversed ) {
					tl.vars.onReverseComplete();
					tl.reverse();
				}
				if ( config.draggable && typeof ( _vendors_Draggable_min__WEBPACK_IMPORTED_MODULE_6___default() ) === 'function' ) {
					let proxy = document.createElement( 'div' ),
						wrap = gsap.utils.wrap( 0, 1 ),
						ratio,
						startProgress,
						draggable,
						dragSnap,
						roundFactor,
						align = () => tl.progress( wrap( startProgress + ( draggable.startX - draggable.x ) * ratio ) ),
						syncIndex = () => tl.updateIndex();
					typeof InertiaPlugin === 'undefined' && console.warn( 'InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club' );
					draggable = _vendors_Draggable_min__WEBPACK_IMPORTED_MODULE_6___default().create( proxy, {
						trigger: items[ 0 ].parentNode,
						type: 'x',
						onPress() {
							startProgress = tl.progress();
							tl.progress( 0 );
							populateWidths();
							totalWidth = getTotalWidth();
							ratio = 1 / totalWidth;
							dragSnap = totalWidth / items.length;
							roundFactor = Math.pow( 10, ( ( dragSnap + '' ).split( '.' )[ 1 ] || '' ).length );
							tl.progress( startProgress );
						},
						onDrag: align,
						onThrowUpdate: align,
						inertia: true,
						snap: ( value ) => {
							const n = Math.round( parseFloat( value ) / dragSnap ) * dragSnap * roundFactor;
							return ( n - n % 1 ) / roundFactor;
						},
						onRelease: syncIndex,
						onThrowComplete: () => gsap.set( proxy, {
							x: 0,
						} ) && syncIndex(),
					} )[ 0 ];
				}
				return tl;
			}
		}
	}

	if ( jQuery( '.comment-reply-link' ).length > 0 ) {
		jQuery( '.comment-reply-link' ).on( 'click', function() {
			jQuery( '.popup-content' ).show();
		} );
	}

	if ( jQuery( '.carousel-blockquote-slider' ).length > 0 ) {
		const owl = jQuery( '.carousel-blockquote-slider' );
		owl.owlCarousel( {
			stagePadding: 200,
			margin: 90,
			items: 1,
			loop: true,
			nav: false,
			autoHeight: false,
			dots: false,
			autoplay: true,
			autoplayTimeout: 10000,
			smartSpeed: 500,
			responsive: {
				0: {
					items: 1,
					stagePadding: 0,
					dots: true,
				},
				600: {
					items: 1,
					stagePadding: 0,
					dots: true,
					margin: 0,
				},
				1004: {
					items: 1,
					stagePadding: 40,

				},
				1179: {
					items: 1,

				},
			},
		} );
		jQuery( '.owl-carousel__next' ).click( () => owl.trigger( 'next.owl.carousel' ) );
		jQuery( '.owl-carousel__prev' ).click( () => owl.trigger( 'prev.owl.carousel' ) );
		jQuery.noConflict();
	}

	if ( jQuery( '.numbered-list-verticle,.video-with-text.video-scale-centner' ).length > 0 ) {
		jQuery( '.numbered-list-verticle-ctn,.video-with-text.video-scale-centner' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'overflow-hidden' );

		const numberedListVerticle = jQuery( '.numbered-list-verticle' );
		numberedListVerticle.owlCarousel( {
			margin: 12,
			items: 3,
			loop: false,
			nav: false,
			dots: false,
			autoHeight: false,
			smartSpeed: 500,
			responsive: {
				0: {
					items: 1,
					stagePadding: 14,
					margin: 28,
					nav: true,
				},
				600: {
					items: 2,
					nav: true,
				},
				1004: {
					items: 3,
				},
			},
		} );
		jQuery( '.numbered_list_next' ).click( () => numberedListVerticle.trigger( 'next.owl.carousel' ) );
		jQuery( '.numbered_list_prev' ).click( () => numberedListVerticle.trigger( 'prev.owl.carousel' ) );
		jQuery.noConflict();
	}

	/**
	 *
	 * 	* Single post sidebar links
	 *
	 */

	if ( jQuery( 'body' ).hasClass( 'single-post' ) ) {
		const headings = jQuery( '.blog-detail__content h2' );
		const headingList = jQuery( '.heading-lists' );

		let count = 1;
		headings.each( function() {
			const id = jQuery( this ).text().trim().toLowerCase().replace( /[^a-zA-Z0-9 ]/g, '' ).replace( /\s/g, '-' );
			jQuery( this ).attr( 'id', id );

			if ( jQuery( this ).text() !== '' ) {
				const listItem = jQuery( '<li></li>' );
				const anchor = jQuery( '<a></a>' );
				anchor.attr( 'href', '#' + id ).html( jQuery( this ).text() );
				listItem.append( anchor );
				headingList.append( listItem );
				count++;
			}
		} );

		// Hide table of content if it's empty
		if ( headingList.html().trim() === '' ) {
			jQuery( '.table-of-content-list' ).hide();
			jQuery( '.sidebar-headings' ).hide(); // Hide sidebar headings if no h2 elements are found
		}

		// Function to check if element is in viewport
		function isInViewport( elem ) {
			const bounding = elem[ 0 ].getBoundingClientRect();
			return (
				bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
            bounding.right <= ( window.innerWidth || document.documentElement.clientWidth )
			);
		}

		// Highlight active section in sidebar based on viewport
		jQuery( window ).on( 'scroll', function() {
			let prevActiveIndex = -1;
			headings.each( function( index ) {
				if ( isInViewport( jQuery( this ) ) ) {
					prevActiveIndex = index;
				}
			} );

			if ( prevActiveIndex !== -1 ) {
				jQuery( '.heading-lists li a' ).removeClass( 'active' );
				jQuery( '.heading-lists li:eq(' + prevActiveIndex + ') a' ).addClass( 'active' );
			}
		} );
	}

	/**
	 *
	 * 	* Comments
	 *
	 */

	jQuery( '.comment-form-popup-btn' ).click( function() {
		jQuery( '.comment-form-popup-btn' ).addClass( 'hide-btn' );
		jQuery( '.popup-content' ).addClass( 'popup-content-show' );
	} );

	jQuery( '.closeBtn' ).click( function() {
		jQuery( '.comment-form-popup-btn' ).removeClass( 'hide-btn' );
		jQuery( '.popup-content' ).removeClass( 'popup-content-show' );
	} );

	jQuery( '.depth-1:lt(2)' ).css( 'display', 'block' );

	jQuery( '.view-all-comment-btn' ).click( function() {
		jQuery( '.view-all-comment-btn' ).addClass( 'hide-btn' );
		jQuery( '.depth-1' ).css( 'display', 'block' );
	} );

	/**
	 *
	 * 	* Aboutp page jumplinks navigation
	 *
	 */

	jQuery( window ).on( 'scroll', function() {
		const windowHeight = jQuery( window ).height();
		const scrollPos = jQuery( document ).scrollTop() + ( windowHeight * 0.3 );

		let activeSectionId = '';

		jQuery( '.jumplink-section' ).each( function() {
			const id = jQuery( this ).attr( 'id' );
			const offsetTop = jQuery( this ).offset().top;

			if ( offsetTop <= scrollPos ) {
				activeSectionId = id;
			}
		} );

		jQuery( '.fixed-menu a[href="#' + activeSectionId + '"]' ).addClass( 'active' );

		jQuery( '.fixed-menu a' ).not( '[href="#' + activeSectionId + '"]' ).removeClass( 'active' );
	} );

	if ( jQuery( window ).width() < 1180 && jQuery( '.changeable-bg' ).length > 0 ) {
		const tween = gsap.to( '.changeable-bg', {
			scrollTrigger: {
				trigger: '.changeable-bg',
				start: 'top center',
				// markers: true,
				onEnter: () => {
					jQuery( '.changeable-bg' ).addClass( 'purple-bg' );
				},
				onLeaveBack: () => {
					jQuery( '.changeable-bg' ).removeClass( 'purple-bg' );
				},
			},
		} );
	}

	if ( jQuery( '.scroll-fixed-title' ).length > 0 ) {
		gsap.to( '.scroll-fixed-title', {
			ease: 'power1.out',
			duration: 1,
			x: '0',
			marginBottom: '-10%',
			scrollTrigger: {
				trigger: '.scroll-fixed-title',
				start: 'top 30% top',
				end: `+=100%`,
				scrub: 1,
				pin: true,
				pinSpacing: false,
			},
		} );
	}

	if ( jQuery( '.top-line' ).length > 0 ) {
		const topLines = document.querySelectorAll( '.top-line' );

		topLines.forEach( ( topLine ) => {
			gsap.fromTo( topLine, {
				x: '50%',
			}, {
				x: '-120%',
				scrollTrigger: {
					trigger: topLine,
					start: 'top 60% top',
					end: ( jQuery( window ).width() > 1179 ) ? '+=200%' : '+=100%',
					scrub: 1,
					// markers: true,
				},
			} );
		} );
	}

	jQuery.noConflict();

	if ( jQuery( '.bottom-line' ).length > 0 ) {
		const bottomLines = document.querySelectorAll( '.bottom-line' );

		bottomLines.forEach( ( bottomLine ) => {
			gsap.fromTo( bottomLine, {
				x: '-50%',
			}, {
				x: '120%',
				scrollTrigger: {
					trigger: bottomLine,
					start: 'top 80% top',
					end: ( jQuery( window ).width() > 1179 ) ? '+=200%' : '+=100%',
					scrub: 1,
					// markers: true,
				},
			} );
		} );
	}

	jQuery.noConflict();

	if ( jQuery( '.ctn-scroll-overlap' ).length > 0 ) {
		const blackCtns = document.querySelectorAll( '.ctn-scroll-overlap' );
		blackCtns.forEach( ( blackCtn ) => {
			gsap.fromTo(
				blackCtn,
				{
					y: '0',
				},
				{
					y: ( jQuery( window ).width() > 1003 ) ? '-90px' : '-48px',
					scrollTrigger: {
						trigger: blackCtn,
						start: 'top 100% top',
						end: '+=100%',
						scrub: 1,
						// markers: true,
					},
				}
			);
		} );
	}

	jQuery.noConflict();

	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.fixed-menu-nav' ).length > 0 ) {
			gsap.to( '.fixed-menu-nav', {
				scrollTrigger: {
					trigger: '.footer-section,.cta-section',
					start: 'top bottom',
					end: `+=100%`,
					scrub: 1,
					pin: false,
					// endTrigger: item,
					// markers: true,
					onEnter: () => {
						jQuery( '.fixed-menu-nav' ).hide();
					},
					onLeaveBack: () => {
						jQuery( '.fixed-menu-nav' ).show();
					},
				},
				duration: 1,
			} );
		}
		jQuery.noConflict();

		if ( jQuery( '.image-gallery-bottom' ).length > 0 ) {
			const galleryheightContent = jQuery( '.image-gallery-bottom' ).outerHeight();

			gsap.to( '.image-collage-grid', {
				scrollTrigger: {
					trigger: '.image-collage-grid',
					start: 'top 15% top',
					end: `+=${ galleryheightContent }`,
					scrub: 1,
					pin: true,
					pinSpacing: false,
					// markers: true,
				},
				duration: 1,
			} );
		}
	}

	jQuery.noConflict();

	/**
	 *
	 * 	* Other scripts without gsap animations
	 *
	 *
	 */

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.bg-change-on-hover' ).on( 'mouseenter', function() {
			jQuery( this ).closest( '.ctn-black' ).addClass( 'purple-bg' );
		} );

		jQuery( '.bg-change-on-hover' ).on( 'mouseleave', function() {
			jQuery( this ).closest( '.ctn-black' ).removeClass( 'purple-bg' );
		} );
		jQuery.noConflict();
	}

	jQuery.noConflict();

	if ( jQuery( '.number-lists' ).hasClass( 'have-load-more' ) ) {
		if ( jQuery( '.number-list' ).length > 0 ) {
			jQuery( '.number-list' ).slice( 0, 3 ).show();
			jQuery( '#number-list-button-btn' ).on( 'click', function( e ) {
				e.preventDefault();
				jQuery( '.number-list:hidden' ).slice( 0, 3 ).slideDown();
				if ( jQuery( '.number-list:hidden' ).length == 0 ) {
					jQuery( '.number-list-button' ).fadeOut( 'slow' );
				}
			} );
		}
	}
	jQuery.noConflict();

	if ( jQuery( '.repeating-text' ).length > 0 ) {
		jQuery( '.repeating-text' ).slice( 0, 4 ).show();
		jQuery( '#repeating-text-loadmore' ).on( 'click', function( e ) {
			e.preventDefault();
			jQuery( '.repeating-text:hidden' ).slice( 0, 4 ).slideDown();
			if ( jQuery( '.repeating-text:hidden' ).length == 0 ) {
				jQuery( '#repeating-text-loadmore,.loadmore-spacer' ).fadeOut( 'slow' );
			}
		} );
	}
	jQuery.noConflict();

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.for-mobile-dropdown .people-grid-item' ).each( function() {
			if ( jQuery( this ).is( ':empty' ) ) {
				jQuery( this ).remove();
			}
		} );

		jQuery( '.for-mobile-dropdown .stacked-row .people-grid-item' ).slice( 0, 3 ).show();
		jQuery( '#loadMore' ).on( 'click', function( e ) {
			e.preventDefault();
			jQuery( '.for-mobile-dropdown .stacked-row .people-grid-item:hidden' ).slice( 0, 20 ).slideDown();
			if ( jQuery( '.for-mobile-dropdown .stacked-row .people-grid-item:hidden' ).length == 0 ) {
				jQuery( '.people-loader-btn' ).fadeOut( 'slow' );
			}
		} );

		jQuery( '.for-mobile-dropdown .people-grid-item' ).each( function() {
			if ( jQuery( this ).is( ':empty' ) ) {
				jQuery( this ).remove();
			}
		} );
	}
	jQuery.noConflict();

	// if ( jQuery( window ).width() < 1004 ) {
	// 	jQuery( '.slider-people-grid .stacked-row .people-grid-item' ).slice( 0, 3 ).show();
	// 	jQuery( '#people-list-button-btn,#people-list-button-btn2' ).on( 'click', function( e ) {
	// 		e.preventDefault();
	// 		jQuery( '.slider-people-grid .stacked-row .people-grid-item:hidden' ).slice( 0, 3 ).slideDown();
	// 		if ( jQuery( '.slider-people-grid .stacked-row .people-grid-item:hidden' ).length == 0 ) {
	// 			jQuery( '.people-list-button' ).fadeOut( 'slow' );
	// 		}
	// 	} );
	// }
	if ( jQuery( window ).width() < 1004 ) {
		const items = jQuery( '.swiper-wrapper .people-grid-item' );
		items.hide().slice( 0, 3 ).show();

		jQuery( '#people-list-button-btn' ).on( 'click', function( e ) {
			e.preventDefault();
			const hiddenItems = items.filter( ':hidden' ).slice( 0, 3 );
			hiddenItems.slideDown();
			if ( typeof swiper !== 'undefined' ) {
				swiper.update();
			}

			if ( items.filter( ':hidden' ).length == 0 ) {
				jQuery( '.people-list-button' ).fadeOut( 'slow' );
			}
		} );
	}
	jQuery.noConflict();

	if ( jQuery( window ).width() < 1004 ) {
		// jQuery( '.image-collage-ctn .image-collage-grid .image-collage' ).slice( 0, 6 ).show();
		const totalSlides = jQuery( '.image-collage' ).length;
		if ( totalSlides > 8 ) {
			jQuery( '.image-collage-btn' ).show();
		}
		jQuery( '#image-collage-button,#image-collage-button2' ).on( 'click', function( e ) {
			jQuery( '.image-collage-ctn .image-collage-grid' ).addClass( 'image-slides-active' );
			e.preventDefault();
			jQuery( '.image-collage-ctn .image-collage-grid .image-collage:hidden' ).slice( 0, 20 ).slideDown();
			if ( jQuery( '.image-collage-ctn .image-collage-grid .image-collage:hidden' ).length == 0 ) {
				jQuery( '.image-collage-btn' ).fadeOut( 'slow' );
			}
		} );
	}
	jQuery.noConflict();

	if ( jQuery( '.comments-area' ).length > 0 ) {
		if ( jQuery( '.comment.depth-1' ).length > 2 ) {
			jQuery( '.view-all-comment-btn' ).show();
		}
		jQuery( '.comment.depth-1' ).hide();
		jQuery( '.comment.depth-1' ).slice( 0, 2 ).show();

		jQuery( '.view-all-comment-btn' ).on( 'click', function( e ) {
			e.preventDefault();
			jQuery( '.comment.depth-1' ).slice( 0, 15 ).slideDown();
			if ( jQuery( '.comment.depth-1:hidden' ).length == 0 ) {
				jQuery( '.view-all-comment-btn' ).fadeOut( 'slow' );
			}
		} );
	}
	jQuery.noConflict();

	if ( jQuery( '.dark-mode-button' ).length > 0 ) {
		jQuery( '.dark-mode-button' ).on( 'click', function() {
			jQuery( 'body' ).toggleClass( 'dark-mode' );
			jQuery( '.header-section' ).toggleClass( 'white-header' );
			jQuery( '.light-mode-dots' ).toggleClass( 'hide' );
			jQuery( '.dark-mode-dots' ).toggleClass( 'hide' );

			const $button = jQuery( this );

		    const $inner = $button.find( '.inner' );
		    const $lighticon = $button.find( '.light-icon' );
		    const $darkicon = $button.find( '.dark-icon' );

			$lighticon.toggleClass( 'hide' );
			$darkicon.toggleClass( 'hide' );

		    const innerText = $inner.text();

		    if ( innerText === 'Dark Mode' ) {
		        $inner.text( 'Light Mode' );
		    } else {
		        $inner.text( 'Dark Mode' );
		    }
		} );

		if ( jQuery( window ).width() < 1180 ) {
			jQuery( '.dark-mode-button' ).on( 'click', function() {
				jQuery( '.header-section' ).removeClass( 'white-header' );
				jQuery( 'body' ).addClass( 'light-mode' );
			} );
		}
	}
	jQuery.noConflict();

	if ( jQuery( '.search-form' ).length > 0 ) {
		// Function to check and add class on page load
		function checkSearchInput() {
			const searchClose = jQuery( '.js-search-close' );
			const searchInput = jQuery( '.search-form input[type="search"]' );

			if ( searchInput.val().trim() !== '' ) {
				searchClose.addClass( 'show-close-icon' );
			} else {
				searchClose.removeClass( 'show-close-icon' );
			}
		}

		// Trigger the function on page load
		checkSearchInput();

		// Bind events for focus and input
		jQuery( '.search-form input[type="search"]' ).on( 'focus input', function() {
			const searchClose = jQuery( '.js-search-close' );
			if ( jQuery( this ).val().trim() !== '' ) {
				searchClose.addClass( 'show-close-icon' );
			} else {
				searchClose.removeClass( 'show-close-icon' );
			}
		} );

		// Bind event for close icon click
		jQuery( '.js-search-close' ).on( 'click', function() {
			jQuery( this ).closest( '.search-form' ).find( 'input[type="search"]' ).val( '' );
			checkSearchInput(); // Trigger the function after clearing the input
		} );
	}
	jQuery.noConflict();

	/**
	 *
	 * 	* Search Form
	 *
	 */

	if ( ( jQuery( window ).width() > 374 ) && ( jQuery( window ).width() < 1004 ) ) {
		if ( jQuery( '.blog-search' ).length > 0 ) {
			jQuery( '#ajax-search-value' ).on( 'click', function() {
				jQuery( '.blog-search' ).addClass( 'search-input' );
				jQuery( '.category-filter' ).css( 'opacity', 0 );
			} );
			jQuery( '.blog-search .form-close-button' ).on( 'click', function() {
				jQuery( '.blog-search' ).removeClass( 'search-input' );
				jQuery( '.category-filter' ).css( 'opacity', 1 );
			} );
		}
	}

	/**
	 * * Drop Down
	 *
	 */

	jQuery( '.select-filter-button' ).on( 'click', function() {
		const dropdown = jQuery( this ).closest( '.select-dropdown-filter' );
		dropdown.find( '.select-filter-button' ).toggleClass( 'is-button-opened' );
		dropdown.find( '.select-filter-list' ).toggleClass( 'is-active-dropdown' );
	} );
	jQuery.noConflict();

	/*
	* * Close popup on anywhere click
	*/

	jQuery( document ).mouseup( function( e ) {
		// const container = jQuery( '.select-filter-list' );
		const dropdowns = jQuery( '.select-dropdown-filter' );
		dropdowns.each( function() {
			const dropdown = jQuery( this );
			const button = dropdown.find( '.select-filter-button' );
			const list = dropdown.find( '.select-filter-list' );
			if ( ! list.is( e.target ) && list.has( e.target ).length === 0 && ! button.is( e.target ) && button.has( e.target ).length === 0 ) {
				list.removeClass( 'is-active-dropdown' );
				button.removeClass( 'is-button-opened' );
			}
		} );
	} );

	jQuery( '.select-dropdown__list-title' ).on( 'click', function() {
		const currenttext = jQuery( this ).text();
		const dropdown = jQuery( this ).closest( '.select-dropdown-filter' );
		dropdown.find( '.select-filter-button' ).removeClass( 'is-button-opened' );
		dropdown.find( '.select-filter-button' ).text( currenttext );
		const list = dropdown.find( '.select-filter-list' );
		list.removeClass( 'is-active-dropdown' );
		dropdown.find( '.select-dropdown__list-title' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );

	const extLink = jQuery( 'body a' ).filter( function() {
		return this.hostname && this.hostname !== location.hostname;
	} );
	extLink.each( function() {
		jQuery( this ).attr( 'target', '_blank' );
		jQuery( this ).addClass( 'external-link' );
	} );
	jQuery.noConflict();

	jQuery( '.open-bio-text-modal' ).magnificPopup( {
		type: 'inline',
		midClick: true,
		fixedContentPos: true,
	} );

	jQuery.noConflict();

	jQuery( '.open-bio-modal' ).magnificPopup( {
		type: 'inline',
		preloader: false,
		modal: true,
		fixedContentPos: true,
		overflowY: 'hidden',
	} );

	jQuery.noConflict();

	jQuery( document ).on( 'click', '.closeBtn', function( e ) {
		e.preventDefault();
		jQuery.magnificPopup.close();
	} );

	jQuery.noConflict();

	jQuery( '.video-popup' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: true,
		iframe: {
			patterns: {
				youtube: {
					index: 'youtube.com/', // URL pattern for YouTube
					id( url ) {
						const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
						const match = url.match( regExp );
						return match && match[ 1 ] ? match[ 1 ] : null;
					},
					src: '', // Empty to set dynamically below
				},
			},
		},
		callbacks: {
			open() {
				const magnificPopup = jQuery.magnificPopup.instance;
				const videoURL = magnificPopup.st.el.attr( 'href' );

				// Extract video ID using regular expression
				const videoID = videoURL.match( /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/ )[ 1 ];

				// Dynamically set the src with autoplay and mute
				magnificPopup.content.find( 'iframe' ).attr( 'src', 'https://www.youtube.com/embed/' + videoID + '?autoplay=1&mute=1' );
			},
			close() {
				// Clear the iframe src to stop the video when the popup closes
				jQuery( '.mfp-iframe' ).attr( 'src', '' );
			},
		},
	} );

	jQuery.noConflict();

	/**
	 * * Stats
	 */

	const a = [];
	function isElementInViewport( el ) {
		const rect = el.getBoundingClientRect();
		return rect.top >= 0 && rect.left >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) && rect.right <= ( window.innerWidth || document.documentElement.clientWidth );
	}
	if ( jQuery( '.stat-heading' ).length > 0 ) {
		jQuery( window ).scroll( function() {
			jQuery( '.stat-heading' ).each( function( index ) {
				if ( ! a[ index ] && isElementInViewport( this ) ) {
					jQuery( this ).find( '.number' ).each( function() {
						const $this = jQuery( this ),
							countTo = $this.attr( 'data-number' );
						jQuery( {
							countNum: $this.text(),
						} ).animate( {
							countNum: countTo,
						}, {
							duration: 2000,
							easing: 'swing',
							step() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
							complete() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
						} );
					} );
					a[ index ] = true;
				}
			} );
		} );
	}

	jQuery.noConflict();

	// Graph Hover and hover out effect

	//team-members
	jQuery( '.chart-content-inner' ).on( 'mouseover', function() {
		jQuery( '.graph-curve' ).removeClass( 'active' );
		jQuery( '.chart-content-inner' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
		jQuery( '.graph-curve[data-id="' + jQuery( this ).attr( 'id' ) + '"]' ).addClass( 'active' );
	} );
	jQuery( '.graph-curve' ).on( 'mouseover', function() {
		jQuery( '.chart-content-inner' ).removeClass( 'active' );
		jQuery( '.graph-curve' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
		jQuery( '.chart-content-inner[id="' + jQuery( this ).attr( 'data-id' ) + '"]' ).addClass( 'active' );
	} );

	setTimeout( () => {
		if ( jQuery( '#daextlwcnf-cookie-notice-container' ).length > 0 ) {
			const cookieBannerHeight = jQuery( '#daextlwcnf-cookie-notice-container' ).outerHeight();
			const footer = jQuery( '.footer-section' );
			if ( footer.length ) {
				footer.css( 'margin-bottom', cookieBannerHeight + 'px' );
			}

			jQuery( '#daextlwcnf-cookie-notice-button-2' ).on( 'click', () => {
				jQuery( '.footer-section' ).css( 'margin-bottom', '0' );
			} );
		}
	}, 1000 );

	jQuery( '.depth-1' ).each( function() {
		const depth2Count = jQuery( this ).find( '.depth-2' ).length;

		if ( depth2Count > 0 ) {
			const buttonHtml = `<div class="replies-more"><span>${ depth2Count }</span> replies</button></div>`;
			jQuery( this ).find( '.comment-body' ).append( buttonHtml );
		}
	} );

	jQuery( '.replies-more' ).click( function() {
		jQuery( '.replies-more' ).not( this ).removeClass( 'read-more-up' );
		jQuery( this ).toggleClass( 'read-more-up' );

		const depth1Element = jQuery( this ).closest( '.depth-1' );
		const depth2Elements = depth1Element.find( '.depth-2' );
		depth2Elements.slideToggle();
	} );

	setTimeout( () => {
		jQuery( '#daextlwcnf-cookie-notice-button-1,#daextlwcnf-cookie-notice-button-2,#daextlwcnf-cookie-settings-button-1,#daextlwcnf-cookie-settings-button-2' ).attr( {
			role: 'button',
			tabindex: '0',
			'aria-label': 'Cookies Button',
		} );

		if ( jQuery( '.carousel-blockquote-slider' ).length > 0 ) {
			jQuery( '.carousel-blockquote-slider .owl-dot' ).attr( {
				role: 'button',
				tabindex: '0',
				'aria-label': 'Go to slide number',
			} );
		}
	}, 500 );

	if ( jQuery( '.footer-newsletter .ginput_recaptcha' ).length > 0 ) {
		jQuery( '.footer-newsletter' ).addClass( 'has-recaptcha' );
	}
	if ( jQuery( '.slider-people-grid' ).length > 0 ) {
		jQuery( '.slider-people-grid' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'overflow-hidden' );
	}
} );
